import { ApolloClient, NormalizedCacheObject, gql } from '@apollo/client'

const INTERSECTION_ARTICLE = gql`
  query IntersectionArticle($id: ID!, $contentLength: Int = 200) {
    article(id: $id) {
      title
      content: plainTextContent(length: $contentLength)
      coverImage {
        croppedUrl
      }
      ogImage {
        croppedUrl
      }
      ogDescription
      url
    }
  }
`

interface GetIntersectionArticleResultInput {
  client: ApolloClient<NormalizedCacheObject>
  id: string
}

export const getIntersectionArticleResult = async ({
  client,
  id,
}: GetIntersectionArticleResultInput) => {
  try {
    const result = await client.query({
      query: INTERSECTION_ARTICLE,
      variables: { id },
    })
    return result.data.article
  } catch (error) {
    return null
  }
}
